module.exports = __webpack_public_path__ + "img/B7.bb5b8ac1.png";